/**
 * The light / dark switch on share links: the app reports a client opens
 * without an account. Each report type has its own layout and header, so
 * instead of a button threaded through every one, this one sits in the same
 * corner on all of them. The app has its own in the account menu and
 * Settings; the public site (free audit results included) is always dark.
 */
import { useLocation } from "react-router-dom";
import { ThemeToggle } from "@/components/ThemeToggle";

const SHARE_ROUTES = [
  /^\/shared\//,
  /^\/(compare|figma)\/s\//,
  /^\/experiments\/[^/]+\/s\//,
];

export function ShareThemeToggle() {
  const { pathname } = useLocation();
  if (!SHARE_ROUTES.some((r) => r.test(pathname))) return null;
  return (
    <div className="fixed bottom-4 left-4 z-40 print:hidden">
      <ThemeToggle className="h-10 w-10 bg-card shadow-[var(--shadow-md)]" />
    </div>
  );
}

export default ShareThemeToggle;
